import React, { useEffect, useState } from "react";
import rest from "../../rest";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { MySnackbar } from "../../components/mySnackbar/MySnackbar";
import DescriptionIcon from "@material-ui/icons/Description";
import SendIcon from "@material-ui/icons/Send";
import { useHistory } from "react-router-dom";
import LoadingIndicator from "../../components/loadingIndicator/LoadingIndicator";
import { Alert, AlertTitle } from "@material-ui/lab";
import ActivitiesDisplay from "./ActivitiesDisplay ";

// Requetes lors de la suppression est un requete qui envoie du HTML
const MesActivites = () => {
  const [activites, setActivites] = useState([]);
  const [state, setState] = useState(false);
  const [snack, setSnack] = useState({});
  const [emptyData, setEmptyData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const history = useHistory();

  const currentUser = useSelector((state) => state.user);
  const manifParams = useSelector((state) => state.manif);

  // Rediriger si pas valider et pas escalade
  useEffect(() => {
    // Existe pas pour l'escalade
    if (manifParams.manifInfos.Ref === "CouEsc") return false;

    rest
      .get("/benevols/planning.json")
      .then((response) => {
        if (response.data.statut !== "valider") {
          history.push("/planning.html");
          setLoading(false);

        }
        setLoading(false);
      })
      .catch((error) => {
        setSnack({
          message: "/benevols/planning.json " + error, show: true, severity: "error",
        });
        setLoading(false);
      });
  }, [history, manifParams.manifInfos.Ref]);

  // Requete concernant les activites dont l'utilisateur est connecté
  useEffect(() => {
    var paramsData = {
      vIdPers: currentUser.User.User_Person_ID,
      allAct: state,
    };
    rest.post(`/benevols/GetActivity.json`, paramsData).then((response) => {
      const data = response.data;
      setActivites(data);
      if (data === undefined || data.length === 0) {
        setEmptyData(true);
      }
      //setState((prev) => !prev);
    });
  }, [refresh, state, currentUser.User.User_Person_ID]);

  const handleChange = (event) => {
    setState(event.target.checked);
  };

  const handleMyFiche = () => {
    window.open("/export/benevoles/tranche/pdf");
  };

  const handleMyFicheByEmail = () => {
    rest.post("/email/sendFicheBenevole", {}).then((response) => {
      if (response.data.Message === "Ok") {
        setSnack({
          message: "Votre fiche bénévole vous a bien été envoyée.",
          show: true,
          severity: "success",
        });
      } else {
        setSnack({
          message: "Votre fiche bénévole vous a bien été envoyée.",
          show: true,
          severity: "success",
        });
        // setSnack({ message: "Une erreur est survenue.", show: true, severity: "error" })
      }
    });
  };

  return (
    <>
      <LoadingIndicator loading={loading} />
      {!loading && (
        <>
          <Grid container>
            <MySnackbar params={snack} />
            <Grid item sm={12}>
              <Grid container spacing={1}>
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state}
                        onChange={handleChange}
                        name="checked"
                        color="primary"
                      />
                    }
                    label="Afficher toutes mes activités (présentes - passées)"
                  />
                </Grid>
                {!emptyData && (
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<DescriptionIcon />}
                      size="medium"
                      style={{ marginBottom: "5px", fontSize: "11px" }}
                      onClick={handleMyFiche}
                    >
                      Ma fiche bénévole
                    </Button>
                  </Grid>
                )}
                {!emptyData && (
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<SendIcon />}
                      size="medium"
                      style={{ marginBottom: "5px", fontSize: "11px" }}
                      onClick={handleMyFicheByEmail}
                    >
                      Recevoir ma fiche par email
                    </Button>
                  </Grid>
                )}
              </Grid>
              {manifParams.manifParams?.InscripionWishlist && (
                <Grid item sm={12} style={{ marginBottom: 20 }}>
                  <Alert severity="success">
                    <AlertTitle style={{ fontWeight: "bold" }}>
                      Statut : Planning validé (définitif)
                    </AlertTitle>
                    Votre planning a été finalisé. Vous pouvez maintenant
                    consulter vos horaires définitifs.
                  </Alert>
                </Grid>
              )}
            </Grid>
            <Grid item sm={12}>
              <ActivitiesDisplay activities={activites} snack={snack} setSnack={setSnack} setRefresh={setRefresh} manifParams={manifParams} />
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default MesActivites;
